import React from 'react';
import { useTranslation } from 'react-i18next';
import ListItemTitleContent from '../ListItemTitleContent';
import ListItemWarningIcon from '../ListItemWarningIcon';

type ListTableNameCellProps = {
    itemCode: unknown;
    itemService: {
        getLocalization: (...args: any[]) => string;
    };
};

/** Localized name + missing-locale warning — no per-row locale switcher. */
const ListTableNameCell = ({ itemCode, itemService }: ListTableNameCellProps) => {
    const { i18n } = useTranslation();

    return (
        <div className="list-table__name">
            <ListItemTitleContent
                localeCode={i18n.resolvedLanguage}
                itemCode={itemCode}
                itemService={itemService}
            />
            <ListItemWarningIcon itemCode={itemCode} itemService={itemService} />
        </div>
    );
};

export default ListTableNameCell;
